import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { AddressModel } from "../models/address.model";
import { ResultModel } from "../models/result.model";
import { CourseModel } from "../models/course.model";
import { StudentModel } from '../models/student.model';
import { MajorModel } from '../models/major.model';

@Injectable({
  providedIn: 'root'
})
export class CourseService extends BaseService {

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<CourseModel[]>>(this.getApiUrl('courses/list'), formData);
  }

  create(course: CourseModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('courses'), course);
  }

  update(course: CourseModel) {
    return this.httpClient.put(this.getApiUrl('courses'), course);
  }

  get(id: string) {
    return this.httpClient.get<{ Course: CourseModel }>(this.getApiUrl('courses/' + id));
  }

  delete(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('courses/' + id));
  }

  listAllRegisteredMajors(id: string, formData?: FormData) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`courses/${id}/majors/registered`), formData);
  }

  listAllRegisteredMajorsForSelect(id: string) {
    return this.httpClient.get<ResultModel<MajorModel[]>>(this.getApiUrl(`courses/${id}/majors/registered`));
  }

  listAllUnregisteredMajorsForSelect(id: string) {
    return this.httpClient.get<ResultModel<MajorModel[]>>(this.getApiUrl(`courses/${id}/majors/unregistered`));
  }

  createCourseMajor(classMajor: { ClassID: string, MajorID: string, InstructorID: string }) {
    var formData = new FormData();
    formData.append('pMajorID', classMajor.MajorID);
    formData.append('pInstructorID', classMajor.InstructorID);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`courses/${classMajor.ClassID}/majors/add`), formData);
  }

  deleteCourseMajor(ClassID: string, MajorID: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`courses/${ClassID}/majors/delete/${MajorID}`));
  }

  listAllRegisteredStudents(id: string, formData?: FormData) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`courses/${id}/students/registered`), formData);
  }

  listAllRegisteredCourseStudentsForSelect(id: string) {
    return this.httpClient.get<ResultModel<StudentModel[]>>(this.getApiUrl(`courses/${id}/students/registered`));
  }

  listAllUnregisteredCourseStudentsForSelect(id: string) {
    return this.httpClient.get<ResultModel<StudentModel[]>>(this.getApiUrl(`courses/${id}/students/unregistered`));
  }

  createCourseStudent(courseID:string, studentID:string) {
    var formData = new FormData();
    formData.append('pStudentID', studentID);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`courses/${courseID}/students/add`), formData);
  }
  
  deleteCourseStudent(courseID:string, studentID:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`courses/${courseID}/students/delete/${studentID}`));
  }

}
